// extracted by mini-css-extract-plugin
export default {"container":"lgpd_container__oLB+L","title-container":"lgpd_title-container__tNLQQ","lgpd-container":"lgpd_lgpd-container__QEQyf","lgpd-content":"lgpd_lgpd-content__qUJ4G"};